<template>
    <a-layout class="flex layout">
        <layout-sidebar  @menubar-change="(e) => {menubar = e}" :menubar="menubar"></layout-sidebar>
        <a-layout>
            <layout-header @menubar-change="menubar = !menubar" :menubar="menubar"></layout-header>
            <a-layout style="display:block;position:relative;" class="layout-box">
                <!-- 首页的内容 -->
                <a-layout-content  v-if="['Index', 'UserModuleIndex', 'HotelStatistics', 'HotelInOutStatistics','NoticeEmailTemplateConfig','NoticeEmailParamsConfig', 'AbstractStatistics'].includes($route.name)" :style="{ margin: 0, minHeight: '100%' }">
                    <router-view/>
                </a-layout-content>
                <!-- 其他页面 -->
                <a-layout-content v-else :style="{ background: '#fff', padding: '20px 20px 0 20px', margin: 0, minHeight: '100%' }">
                    
                    <!-- 三级路由 -->
                    <template v-if="fourRouteList.length">
                        <a-tabs class="third-nav" style="margin-top:-10px" @change="handleThirdRouteEvent" v-model="tabCurrentName">
                            <a-tab-pane v-for="item in fourRouteList" :tab="item.module_name" :key="item.name">
                                <!-- <div @click="handleThirdRouteEvent(index)" slot="tab">{{item.module_name}}</div> -->
                            </a-tab-pane>
                        </a-tabs>
                        <router-view/>
                    </template>

                    <!-- 工具页的内容 -->
                    <template  v-else-if="$route.name == 'toolList'">
                        <router-view/>
                    </template>

                    <!-- iframe嵌套 -->
                    <iframe style="position:absolute;left:0;top:0;bottom:0;right:0;width:100%;height:100%;" v-else-if="$route.meta.iframe" :src="$route.meta.iframe.replace(':meeting_id',$route.params.meeting_id)" frameborder="0"></iframe>

                    <!-- 带标题的内容 -->
                    <template v-else>
                        <div class="common-title">
                            {{$route.meta.title}}
                        </div>
                        <div class="common-content" >
                            <router-view/>
                        </div>
                    </template>  

                </a-layout-content>
            </a-layout>
        </a-layout>
    </a-layout>
</template>

<script>
import layoutHeader from './header.vue';
import layoutSidebar from './sidebar.vue';
import { mapState } from 'vuex';
export default {
    name: "AdminLayout",
    components: { layoutHeader, layoutSidebar },
    props: {

    },
    computed:{
        ...mapState('asidebar',[
            'fourRouteList',
            'routeLevel'
        ]),
    },
    watch:{
        '$route':{
            handler(newVal) {
                this.tabCurrentName = this.$route.name;
            },
            immediate:true,
        }
    }, 
    data() {
        return {
            tabCurrentName:null,
            menubar:true,
        }
    },
    methods: { 
        handleThirdRouteEvent(name){
            let currItem = this.fourRouteList.filter(it => it.name == name);
            if(!currItem.length){ return false; }
            currItem = currItem[0];
            let path = currItem.path;
            if(path.indexOf('http') != -1){
                window.open(path, "_blank");
            }else{
                let { lang,meeting_id,forum_id } = this.$route.params;
                path = path.replace(':lang',lang).replace(':meeting_id',meeting_id).replace(':forum_id',forum_id);
                this.$router.push(path)
            }
        }
    },
    mounted() {
    },
}
</script>

<style lang="less" scoped>
.layout{
    height:100vh;
    &-box{
        padding:15px 0 0 15px;
        overflow: auto;
    }
    .common-title{
        font-size:16px;
        font-weight: bold;
        line-height: 45px;
        padding-left:15px;
        margin-top:-10px;
        border-bottom:1px solid @border-color;
    }
    .common-content{
        padding:15px;
        position: relative;
    }
    .third-nav /deep/.ant-tabs-tab{
        font-size:16px;
    }
}
@media screen and (max-width: 768px){
    .layout{
        /deep/.ant-layout-content{
            padding:10px!important;
            overflow: auto!important;
        }
        .common-title{
            padding-left:10px;
        }
        .layout-box{
            padding:10px;
        }
    }
}
</style>